export let content = {
    English: {
      firstlink:"Home",
      secondlink:"Our Services",
      thirdlink:"About Us",
      fourthlink:"Gallery",
      fifthlink:"Testimonial",
      desc:"Don't Hesitate to Contact Us for further inquiries!",
      wa:"Lets Talk",
      email:"Request Form",
      desc2:"We arrange all your visa applications to abroad or visas in Bali with a guarantee 99% approved!",
      copy:"All Rights Reserved",
      legal:"Legal And Payment Details",
      legaldetails:"All the payment can be settled by Cash or Transfer to our Bank company account:\n\nBANK BCA, CAB/ SANUR\nACCOUNT NO: 7730316083\nACCOUNT NAME: VINSENSIUS JEHAUT\nSWIFT CODE: CENAIDJA\nWith Business license (SIUP) : 2017/22-08/BPPT/SIUP-K/IV/2016\nBusiness Registration Number (NIB) : 0290010222619\nNPWP : 02.970.886.4-905.000",
      akte:"Notarial Deed"
    },  
    Indonesia:{
      firstlink:"Halaman Utama",
      secondlink:"Layanan Kami",
      thirdlink:"Tentang Kami",
      fourthlink:"Galeri",
      fifthlink:"Testimoni / Kesaksian",
      desc:"Jangan Ragu untuk Menghubungi Kami untuk info lebih lanjut!",
      wa:"Hubungi Kami",
      email:"Request Form",
      desc2:"Kami mengatur semua aplikasi visa Anda ke luar negeri atau visa di Bali dengan jaminan 99% disetujui!",
      copy:"Hak Cipta Dilindungi",
      legal:"Detail Hukum Dan Pembayaran",
      legaldetails:"Semua pembayaran dapat diselesaikan secara Tunai atau Transfer ke rekening perusahaan Bank kami:\n\nBANK BCA, CAB/ SANUR\nNO REKENING: 7730316083\nNAMA AKUN: VINSENSIUS JEHAUT\nKODE SWIFT: CENAIDJA\nDengan Surat Izin Usaha (SIUP) : 2017/22-08/BPPT/SIUP-K/IV/2016\nNomor Induk Berusaha (NIB) : 0290010222619\nNPWP : 02.970.886.4-905.000",
      akte:"Akta Notaris"
    }
  };
  